import { Button, Tooltip } from '@mui/material';
import { DataCellProps } from '../types';
import { ImpersonateLoadingButton } from 'TeamModule/components/ImpersonateAccountMenu/ImpersonateLoadingButton';
import { MemberRoles } from 'TeamModule/constants/member';
import { useGrowthBookFlag } from 'hooks/useGrowthBookFlag';

export const MembersV2ImpersonateCell = ({
  onImpersonate,
  impersonationItem,
  isLoadingImpersonation,
  isImpersonationError,
}: DataCellProps) => {
  const hasData = Boolean(impersonationItem?.accountId && impersonationItem?.tags);
  const isStillLoading = !hasData && isLoadingImpersonation;
  // GLX-1255: No Access members cannot log in to Mosaic, so they cannot be impersonated
  const isNoAccess = impersonationItem?.roleName === MemberRoles.NoAccess;
  // GLX-2015: nor can members whose sign-in is turned off
  const { isOn: isSignInStatusOn } = useGrowthBookFlag('memberManagementTableV2Flag');
  const isInactive = isSignInStatusOn && impersonationItem?.loginEnabled === false;

  const getTooltipMessage = () => {
    if (isStillLoading) return 'Loading impersonation data...';
    if (isNoAccess) return 'No access to the Mosaic team';
    if (isInactive) return 'Sign-in is turned off for this member';
    if (hasData) return '';
    if (isImpersonationError) return 'Failed to load impersonation data';
    return 'Impersonation data unavailable';
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onImpersonate?.(event);
  };

  if (isStillLoading) {
    return <ImpersonateLoadingButton />;
  }

  const isDisabled = !hasData || isNoAccess || isInactive;

  return (
    <Tooltip title={getTooltipMessage()}>
      <span>
        <Button
          color="primary"
          variant="outlined"
          onClick={isDisabled ? undefined : handleClick}
          disabled={isDisabled}
        >
          Impersonate
        </Button>
      </span>
    </Tooltip>
  );
};

export default MembersV2ImpersonateCell;
